import BaseStore from './BaseStore'

export class UserPropertyStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'user_properties'
  }
}

export default new UserPropertyStore()


// WEBPACK FOOTER //
// ./src/stores/UserPropertyStore.js